import { DemandInformationCategory } from '../../../types/DemandInformationMessage';
import { CategoryState } from '../../../types/ReachInformationMessage';

/**
 * Determines the highest priority category state for a vessel based on its categories.
 * Uses a priority order where SAFETY_RESERVE has the highest priority, followed by
 * WARNING_LIMIT, OUT_OF_REACH, and IN_REACH.
 *
 * @param categories - Array of demand information categories for a vessel
 * @returns The highest priority category state found, or null if no categories have states
 */
export const getHighestPriorityCategoryState = (categories: DemandInformationCategory[]): CategoryState | null => {
    const priorityOrder = [
        CategoryState.SAFETY_RESERVE,
        CategoryState.WARNING_LIMIT,
        CategoryState.OUT_OF_REACH,
        CategoryState.IN_REACH,
    ];

    return (
        priorityOrder
            .map((priority) => categories.find((category) => category.categoryState === priority)?.categoryState)
            .find((state) => state !== undefined) ?? null
    );
};
